import {Component, OnInit, Inject, ViewEncapsulation, OnDestroy} from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { AppService } from '@irb/app.service';
import { IrbCreatePortfolioEvents, IrbAppEvents } from '@irb-common/events';
import { ImportCashSettingsResultGridLayoutService } from '@irb/irb-clients/import-cash-settings-result-dialog/import-cash-settings-result.grid-layout.service';
import { IrbCreatePortfolioService } from '@irb/irb-create-portfolio/irb-create-portfolio.service';
import { IAlertDialogData } from '@irb/app.model';

@Component({ standalone: false,
  selector: 'irb-import-accounts-to-portfolio-result-dialog',
  templateUrl: './import-accounts-to-portfolio-result-dialog.component.html',
  styleUrls: ['./import-accounts-to-portfolio-result-dialog.component.scss', '../../irb-common/styles/dialog.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ImportAccountsToPortfolioResultDialogComponent implements OnInit, OnDestroy {
  grid: any;
  gridOptions: any;
  isUiTest = false;
  progressBarValue = 0;
  showProgressBar = false;
  updateStatusCount = 0;
  progressTimer: any = null;
  frameworkComponents: any;

  constructor(
      public dialogRef: MatDialogRef<ImportAccountsToPortfolioResultDialogComponent>,
      @Inject(MAT_DIALOG_DATA) public mdd: any,
      public as: AppService,
      private gls: ImportCashSettingsResultGridLayoutService,
      private cps: IrbCreatePortfolioService
  ) {
    this.gridOptions = {
      columnDefs: this.gls.getColumnDefs(),      
      floatingFilter: false,
      overlayNoRowsTemplate: "<span class='ag-overlay-loading-center ag-overlay-message'>No results.</span>",
      context: { componentParent: this }
    };
    
    this.frameworkComponents = this.gls.getFrameworkComponents();
  }

  ngOnInit() {
  }

  close() {
    this.dialogRef.close();
  }

  onGridReady(params: any) {
    this.grid = params;
  }

  completeImport() {
    this.as.fireEvent(IrbCreatePortfolioEvents.SHOW_PORTFOLIO_IMPORT_HOLDINGS, {
      portfolioAccounts: this.mdd.accountVeoList,
      isAltWorkflow: true,
      //isUnassignedAccountImport: true,
      //acctPortImportDTO: this.mdd.acctPortImportDTO,
      finishButtonLabel: "Finish importing assignments",
      finishButtonCallback: (() => this.finishButtonCallBack())
    });

    this.close(); //sa 2023-08-21 this one closes itself and progress bar never shows up
  }

  finishButtonCallBack() {
    this.as.fireEvent(IrbAppEvents.SHOW_WAIT);
    this.cps.createPFforUnassignedAccountImportAsync(this.mdd.acctPortImportDTO).subscribe((response: any) => {
      this.updateStatusCount = 0;
      this.progressTimer && clearTimeout(this.progressTimer);
      this.showProgressBar = true;
      this.updateStatusCount = 0;
      if (response.responseUtilityMap)
        this.actionStatusCheckIntervalStart(response.responseUtilityMap.statusId);
    }, () => {
      this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
    });
  }

  updateProgressBarStatus(response: any) {
    const cnt: any = response.failedRecCount + response.successRecCount;
    const rcnt: any = response.recievedCount;
    if (rcnt > 0) {
      const progressPercentage = Math.floor((cnt * 100) / rcnt);
      this.progressBarValue = progressPercentage;
    }
    let timeout = (this.updateStatusCount > 10) ? 8000 : (this.updateStatusCount > 2) ? 3000 : 1500;
    if (this.isUiTest)
      timeout = 0;
    this.updateStatusCount++;
    this.progressTimer = setTimeout(() => {
      this.actionStatusCheckIntervalStart(response.statusId);
    }, timeout);
  }

  actionStatusCheckIntervalStart(actionStatusId: any) {
    this.cps.actionStatusCheck(actionStatusId).subscribe((statusResponse: any) => {
      if (statusResponse.responseStatus === "SUCCESS") {
        const response = statusResponse.responseData;
        const reqStatus = response.reqStatus.trim().toUpperCase();
        if (reqStatus === 'FAILED') {
          this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
          if (response.failMsg && response.failMsg.toUpperCase() === 'STALEDATAEXCEPTION')
            this.showStaleDataDialog();
          else
            this.actionStatusCheckFailed(response);
        }
        if (reqStatus === 'STARTED' || reqStatus === 'NEW' || reqStatus === 'IN_PROGRESS') {
          this.updateProgressBarStatus(response);
        }
        if (reqStatus === 'COMPLETED') {
          this.close();
          this.progressTimer && clearTimeout(this.progressTimer);
          this.as.fireEvent(IrbAppEvents.GRID_REFRESH);
          this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
            severity: 'success',
            summary: 'Import Accounts to Portfolio',
            detail: response.recievedCount + " accounts were removed from this list and assigned to portfolios."
          });
          this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
        }
      } else {
        this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
        this.close();
        this.progressTimer && clearTimeout(this.progressTimer);
      }
    }, () => {
      this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
      this.close();
      this.progressTimer && clearTimeout(this.progressTimer);
    });
  }

  actionStatusCheckFailed(response: any) {
    this.close();
    this.as.fireEvent(IrbAppEvents.GRID_REFRESH);
    this.as.fireEvent(IrbAppEvents.SHOW_ALERT, {
      dType: 'ERROR',
      dTitle: '',
      dProceedBtnLabel: '',
      msg: response.failMsg,
      onProceed: () => {
      }
    });
  }

  showStaleDataDialog() {
    this.close();
    this.as.fireEvent(IrbAppEvents.GRID_REFRESH);
    this.as.fireEvent(IrbAppEvents.SHOW_CONFIRMATION, {
      dTitle: 'Refresh Required',
      dProceedBtnLabel: 'Refresh',
      msg: "You are attempting to create or update accounts that was just modified by someone else. To see the updated accounts, you need to refresh the page.",
      onProceed: () => {
        this.as.fireEvent(IrbAppEvents.GRID_REFRESH);
      }
    });
  }

  ngOnDestroy() {
    this.progressTimer && clearTimeout(this.progressTimer);
  }
}

